import { render, staticRenderFns } from "./BaseTextInput.vue?vue&type=template&id=3fcb35b8&scoped=true&"
import script from "./BaseTextInput.vue?vue&type=script&lang=ts&"
export * from "./BaseTextInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcb35b8",
  null
  
)

export default component.exports